'use client';

import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import { useState } from 'react';
import css from './index.module.scss';
import QuoteWin from './QuoteWin';

const FREE_QUOTE_PAGE_MAP: Record<string, string> = {
    '/delta-pro-ultra': 'DELTA Pro Ultra',
    '/delta-pro-3-portable-power-station': 'DELTA Pro 3',
    '/delta-pro-portable-power-station': 'DELTA Pro',
};

export default function WidgetsItemFreeQuote() {
    const { locale = '', pathname = '' } = getLocal();
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);
    const productName = FREE_QUOTE_PAGE_MAP[pathname];

    if (!(locale === 'us' && productName)) {
        return null;
    }

    const quoteCallback = (type: string) => {
        setOpenQuoteFlag(type === 'open');
    };

    const openFreeQuote = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_get_a_quote',
                button_name: 'Get a Free Quote',
                product_name: productName,
                position: 'Introduction',
                option_name: 'Floating_Get a Free Quote',
                __btn_type: 'common',
                __btn_id1: 'WidgetsItem-FreeQuote',
                __btn_id2: 'Get a Free Quote',
            });
        } catch (error) {
            console.error(error);
        } finally {
            quoteCallback('open');
        }
    };

    return (
        <>
            <div className={`Widgets-box-in2-item WidgetsItem-FreeQuote ${css.section}`} onClick={openFreeQuote}>
                <div className="title">
                    <span>Get a Free Quote</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                            d="M5.78088 11.2266L9.95764 8.23535L5.78088 5.24381L6.55725 4.15983L11.4908 7.69336C11.6655 7.81856 11.7692 8.02042 11.7692 8.23535C11.7691 8.45028 11.6656 8.65218 11.4908 8.77734L6.55725 12.3105L5.78088 11.2266Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div className="action-button"></div>
            </div>
            {openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </>
    );
}
